import { cn } from "@/libs/utils";

interface SpinnerProps extends React.HTMLAttributes<HTMLDivElement> {}

export function Spinner({ className, ...rest }: SpinnerProps) {
  return (
    <div
      className={cn(
        "relative flex size-[60px] items-center justify-center",
        className,
      )}
      {...rest}
    >
      {Array.from({ length: 8 }).map((_, index) => (
        <div
          key={index}
          className={cn(
            `absolute size-2 transform animate-color-change rounded-full`,
          )}
          style={{
            transform: `rotate(${index * 45}deg) translate(150%, 150%)`,
            animationDelay: `${index * 0.125}s`,
          }}
        ></div>
      ))}
    </div>
  );
}
